<div
  class="card-item-main"
  [class.completed]="card().completed"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  tabindex="0"
  role="button"
  [attr.aria-label]="'Open ' + card().header"
>
  <div class="card-item-main-inner">
    <div class="card-item-main-image">
      <ptl-card-image [src]="card().image" [alt]="card().header" [cardIndex]="cardIndex()"></ptl-card-image>

      <div *ngIf="card().completed" class="card-item-main-completion-indicator">
        <ptl-icon [icon]="CheckmarkCircle02Icon" size="s"></ptl-icon>
      </div>

      <div *ngIf="card().lmsPlatformType" class="card-item-main-lms-badge">
        {{ lmsPlatformLabel() }}
        <ptl-icon [icon]="LinkSquare02Icon" size="xs"></ptl-icon>
      </div>
    </div>

    <div class="card-item-main-content">
      <div class="card-item-main-type-badge" *ngIf="card().collectionType">{{ card().collectionType }}</div>
      <h3 class="card-item-main-title">{{ card().header }}</h3>
      <p *ngIf="cardSubheader()" class="card-item-main-subtitle">{{ cardSubheader() }}</p>
    </div>
  </div>
</div>
